// File types accepted for population and IPE-proof uploads.
// Keep in sync with skeptics-backend/constants (PopulationAllowedExtensions) and
// skeptics-ai-service/module3/utils/population_formats.py.

export const POPULATION_EXTENSIONS = [
  // tabular: parsed exactly, no AI
  '.xlsx', '.xlsm', '.xls', '.csv', '.tsv',
  // Word
  '.docx', '.doc',
  // text-bearing documents
  '.pdf', '.txt', '.json',
  // images, read with AI vision (flagged for review)
  '.png', '.jpg', '.jpeg', '.webp', '.heic', '.heif', '.tif', '.tiff', '.bmp', '.gif',
] as const;

/** Value for an <input type="file" accept="..."> attribute. */
export const POPULATION_ACCEPT = POPULATION_EXTENSIONS.join(',');

/** Short human description for upload drop zones. */
export const POPULATION_FORMATS_LABEL = 'Excel, CSV, Word, PDF, or image (PNG, JPG, …)';

export function isSupportedPopulationFile(file: { name?: string } | null | undefined): boolean {
  const name = (file?.name || '').toLowerCase();
  const dot = name.lastIndexOf('.');
  return dot >= 0 && (POPULATION_EXTENSIONS as readonly string[]).includes(name.slice(dot));
}

export const UNSUPPORTED_POPULATION_FILE_MESSAGE =
  'Unsupported file type. Upload an Excel, CSV, Word, PDF, text, or image file.';
